import { useEffect, useState } from "react";
import { useLanguage } from "@/i18n";
import { setAppLang } from "@/i18n/appLang";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { StudioLayout } from "./StudioLayout";
import { DocumentBranding } from "@/components/DocumentBranding";
import { studio, apiError, btnPrimary, btnGhost } from "@/lib/studioApi";
import { ListSkeleton } from "@/components/studio/StudioUI";

export default function StudioOnboarding() {
  const { lang: siteLang } = useLanguage();
  useEffect(() => { setAppLang(siteLang); return () => setAppLang("fr"); }, [siteLang]);
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    studio.get("/profile").then(({ data }) => setProfile(data)).catch(() => toast.error("Chargement impossible."));
  }, []);

  const finish = async () => {
    setSaving(true);
    try {
      await studio.put("/profile", {
        ...profile,
        quote_validity_days: Number(profile.quote_validity_days) || 30,
        target_margin_percent: Number(profile.target_margin_percent) || 0,
        hourly_cost: Number(profile.hourly_cost) || 0,
      });
      toast.success("Vos documents sont à votre charte.");
      navigate("/studio");
    } catch (e) { toast.error(apiError(e, "Enregistrement impossible.")); }
    finally { setSaving(false); }
  };

  return (
    <StudioLayout
      title="Vos documents à votre image"
      subtitle="Ajoutez votre logo et choisissez vos couleurs : devis, rapports et factures les reprendront automatiquement. Vous pourrez modifier tout ça à tout moment dans votre profil."
    >
      {!profile && <ListSkeleton />}
      {profile && (
        <div className="mt-6 space-y-4">
          <DocumentBranding profile={profile} setProfile={setProfile} />
          <div className="flex flex-wrap gap-2">
            <button type="button" data-testid="onboarding-finish" disabled={saving} onClick={finish} className={btnPrimary}>
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <ArrowRight className="w-4 h-4" />} C'est prêt, aller au Studio
            </button>
            <button type="button" data-testid="onboarding-skip" onClick={() => navigate("/studio")} className={btnGhost}>
              Plus tard
            </button>
          </div>
        </div>
      )}
    </StudioLayout>
  );
}
